import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { JwtService } from '../services/jwt.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Config } from '../config/config'
import { TokenService } from '../services/token.service'
import { AuthService } from '../services/auth.service'
import { SnotifyService } from 'ng-snotify'
import { LocalStorageService } from 'src/app/services/local-storage.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  /**
   * Formulário de login
   */
  loginForm: FormGroup

  /**
   * Define se o formulário foi enviado.
   */
  submitted = false

  /**
   * Configuração
   */
  config: Config = new Config

  /**
   * Mensagem de erro.
   */
  errorMessage: string

  /**
   * Status de erro.
   */
  errorStatus: number

  /**
   * Elemento Body
   */
  private elementBody: any

  /**
   * Define se o CAPS LOCK está ligado.
   */
  public capsLockLigado: boolean


  /**
   * Paramentros para o background particle.
   */
  public paramsParticle: any

  /**
   * Altura do componente de particle.
   */
  public heightParticle = 100

  /**
   * Largura do componente de particle.
   */
  public widthParticle = 100

  /**
   * Estilos para o componente particle.
   */
  public styleParticle: any

  /**
   * Versão atualização da aplicação vinda da API
   */
  private currentVersion = null

  /**
   * Armazena versão da aplicação
   */
  public versionInApp: any

  /**
   * Armeza as integrações de login
   */
  public integracoes : Array<any> = new Array;

  public load: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private jwtService: JwtService,
    private token: TokenService,
    private router: Router,
    private auth: AuthService,
    private notify: SnotifyService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
      this.styleParticle = {
      'position': 'fixed',
      'width': '100%',
      'height': '100%',
      'z-index': -1,
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0,
    }

    this.elementBody = document.getElementsByTagName('body')[0]
    this.elementBody.classList.add('login')

    this.loginForm = this.formBuilder.group({
      user: ['', [Validators.required]],
      password : ['', [Validators.required]]
    })

    document.onkeypress = (e: any) => {
      e = (e) ? e : window.event

      let charCode = 0
      if (e.which) {
        charCode = e.which
      } else if (e.keyCode) {
        charCode = e.keyCode
      }

      let shifton = false
      if (e.shiftKey) {
        shifton = e.shiftKey
      } else if (e.modifiers) {
        shifton = !!(e.modifiers && 4)
      }

      if (charCode >= 97 && charCode <= 122 && shifton) {
        this.capsLockLigado = true
        return true
      }

      if (charCode >= 65 && charCode <= 90 && !shifton) {
        this.capsLockLigado = true
        return true
      }

      this.capsLockLigado = false

    }

    if(this.token.loggedIn()){
        this.redirectLoggedArea();
    }
  }
  /**
   * Funcionalidade de retornars os controles do formulário.
   */
  get f() { return this.loginForm.controls }

  /**
   * Evento de submissão do formulário.
   */
  onSubmit() {
    this.submitted = true
    this.load = true

    if (this.loginForm.invalid) {
      return
    }

    this.jwtService.login(this.loginForm.controls.user.value, this.loginForm.controls.password.value).subscribe(
      data => {
        this.handleResponse(data)
      },
      error => {
        this.handleError(error)
      }
    )
  }


  /**
   * Resposta da requisição de login.
   * @param data Dados da resposta.
   * @param redirect Caso deva ser redirecionado novamente para o selecionar filiais.
   */
  async handleResponse(data, redirect = true) {
    this.load = false
    await this.token.handle(data.access_token)
    this.auth.changeAuthStatus(true)
    this.notify.success('Autenticado com sucesso!')
    this.redirectLoggedArea();
  }

  /**
   * Resposta de erro da requisição
   * @param error Dados de erro da requisição
   */
  handleError(error) {
    this.load = false
    this.errorStatus = error.status
    if (error.status == 401) {

    }
  }

  ngOnDestroy(): void {
    this.elementBody.classList.remove('login')
  }

  private redirectLoggedArea()
  {
      this.router.navigateByUrl('/dashboard');
  }
}
